import { renderDefaultGridCell } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/WorkExperienceTab/components/gridComponents/DefaultGridCell';
import { XGridDefaultColumn } from '@AMIEWEB/Common/XGrid/cells/XGridDefaults';
import { getAmount, getPercentage } from '../../OrderPreferences/TargetMargins/OrderTargetMarginHelper';
import { isNumber } from 'lodash';
import { renderEditMarginCell } from './PercentEditCell';
import { missingField } from 'app/constants';
import { renderLoadableCell } from './LoadableCell';
import { XGridOverflowCell } from '@AMIEWEB/Common/XGrid/cells/XGridOverflowCell';
import { formatIfFractional } from 'app/helpers/numberHelper';
import moment from 'moment';
import { MISSING_FIELD } from '@AMIEWEB/Notification/Constants';
const OrderPayPackageDefaultCell = {
  ...XGridDefaultColumn,
  flex: 0,
};
const enforceDecimal = true;
export const orderPayPackageColumns = t => [
  {
    ...OrderPayPackageDefaultCell,
    field: 'skillset',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.skillset'),
    width: 200,
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'shift',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.shift'),
    width: 100,
    renderCell: params => XGridOverflowCell()()({ ...params, value: params.value ?? missingField }),
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'minimumRequiredHours',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.minimumRequiredHours'),
    width: 150,
    renderCell: params => params.value ?? missingField,
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'publishingStatus',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.postingStatus'),
    width: 100,
    valueParser: value => value ?? missingField,
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'originalTargetMargin',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.targetMargin'),
    width: 100,
    renderCell: params =>
      renderLoadableCell({
        renderComponent: renderDefaultGridCell({
          ...params,
          value: getPercentage(isNumber(params?.value) ? Number(params?.value) : undefined),
        }),
        params,
      }),
  },
  {
    field: 'currentTargetMargin',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.margin'),
    width: 100,
    editable: true,
    ...getCurrentTargetMarginCell(t),
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'weeklyGrossPay',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.weeklyGrossPay'),
    width: 100,
    renderCell: params =>
      renderLoadableCell({
        renderComponent: renderDefaultGridCell({
          ...params,
          value: formatIfFractional(params?.value ,  0,'$'),
        }),
        params,
      }),
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'minimumWeeklyGrossPay',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.minimumWeeklyGrossPay'),
    width: 150,
    renderCell: params =>
      renderLoadableCell({
        renderComponent: renderDefaultGridCell({
          ...params,
          value: formatIfFractional(params?.value ,  0,'$'),
        }),
        params,
      }),
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'maximumWeeklyGrossPay',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.maximumWeeklyGrossPay'),
    width: 150,
    renderCell: params =>
      renderLoadableCell({
        renderComponent: renderDefaultGridCell({
          ...params,
          value: formatIfFractional(params?.value ,  0,'$'),
        }),
        params,
      }),
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'billRate',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.billRate'),
    width: 75,
    renderCell: params =>
      renderDefaultGridCell({
        ...params,
        value: formatIfFractional(params?.value ,  2,'$',enforceDecimal),
      }),
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'vms',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.vmsFee'),
    width: 75,
    renderCell: params =>
      renderLoadableCell({
        renderComponent: formatIfFractional(params?.value ,  2,'',enforceDecimal,'%'),
        params,
      }),
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'other',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.otherFee'),
    width: 75,
    renderCell: params =>
      renderLoadableCell({
        renderComponent: formatIfFractional(params?.value ,  2,'',enforceDecimal,'%'),
        params,
      }),
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'payRate',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.payRate'),
    width: 75,
    renderCell: params =>
      renderLoadableCell({
        renderComponent: formatIfFractional(params?.value ,  2,'$',enforceDecimal),
        params,
      }),
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'lodgingPerDiem',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.lodgingPerDiem'),
    width: 150,
    renderCell: params =>
      renderLoadableCell({
        renderComponent: formatIfFractional(params?.value ,  2,'$',enforceDecimal),
        params,
      }),
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'mealPerDiem',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.mealPerDiem'),
    width: 150,
    renderCell: params =>
      renderLoadableCell({
        renderComponent: formatIfFractional(params?.value ,  2,'$',enforceDecimal),
        params,
      }),
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'orientationHours',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.orientationHours'),
    width: 150,
    renderCell: params => params.value ?? missingField,
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'updatedDateAt',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.lastUpdatedDate'),
    width: 150,
    hide: true,
    renderCell: params =>
      renderLoadableCell({
        renderComponent: moment(params.value).format('MM/DD/YYYY hh:mm:ss A') ?? missingField,
        params,
      }),
  },
  {
    ...OrderPayPackageDefaultCell,
    field: 'updatedByName',
    headerName: t('order.payPackagesTab.orderPayPackages.grid.column.lastUpdatedBy'),
    width: 150,
    hide: true,
    renderCell: params =>
      renderLoadableCell({
        renderComponent: params.value ?? missingField,
        params,
      }),
  },
];

export const defaultPinnedColumns = {
  left: [],
  right: [],
};

export const orderPayPackagesColumnVisibility = {
  skillset: true,
  shift: true,
  minimumRequiredHours: true,
  publishingStatus: true,
  originalTargetMargin: true,
  currentTargetMargin: true,
  weeklyGrossPay: true,
  minimumWeeklyGrossPay: true,
  maximumWeeklyGrossPay: true,
  billRate: true,
  vms: true,
  other: true,
  payRate: true,
  lodgingPerDiem: true,
  mealPerDiem: true,
  orientationHours: true,
  updatedDateAt: false,
  updatedByName: false,
};

export const getCurrentTargetMarginCell = t => ({
  // 1) Display as XX.XX%
  valueFormatter: ({ value }) => (value == null || Number.isNaN(Number(value)) ? MISSING_FIELD : `${Number(value).toFixed(2)}%`),

  // 2) Parse user input (accepts e.g. "12.3" or "12.3%")
  valueParser: value => {
    const num = parseFloat(String(value).replace(/[^\d.-]/g, ''));
    return Number.isNaN(num) ? null : num;
  },

  // 3) Validate on edit (blocks commit on blur/Enter if invalid)
  //    - not NaN
  //    - 0 <= value <= 100
  //    - up to 2 decimal places
  preProcessEditCellProps: params => {
    const raw = String(params.props.value ?? '');
    const v = Number(raw);
    const twoDecimals = /^\d{0,3}(\.\d{0,2})?$/.test(raw); // allows 0..100 with 2 dp
    const inRange = !Number.isNaN(v) && v >= 0 && v <= 100;
    return { ...params.props, error: !(inRange && twoDecimals) };
  },
  renderEditCell: params => renderEditMarginCell(params),
  renderCell: params =>
    renderLoadableCell({
      renderComponent: params.formattedValue,
      params,
    }),
});
